import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms'; 
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router'; 
import { ClientService } from '../_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
})
export class AddClientComponent implements OnInit {
  contactUUID: string = "";
  contactTypeList: any = [];
  languageList: any = [];
  referralList: any = [];
  clientInfo: any = {};
  clientAutoInfo: any = [];
  clientEmails: any = [];
  clientContactTypes: any = [];
  preappendtype: string = "";
  email_i: number = 0;
  update_message: string = "";
  curr_contact_type: number = 0;
  autoClientsName: string = "";

  addClientForm: FormGroup = new FormGroup({
    first_name: new FormControl(""),
    last_name: new FormControl(""),
    gender: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl("Qc"),
    postalcode: new FormControl(""),
    country: new FormControl("Canada"),
    language: new FormControl(""),
    referral: new FormControl(""),
    referral_note: new FormControl(""),
  })

  clientTypeForm: FormGroup = new FormGroup({});

  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private client: ClientService,
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    this.client.getClientListContactTypes$(contactUUID)
      .subscribe((data: any[]) => {
        this.contactTypeList = data;

        this.clientContactTypes[1]= [];
        this.clientContactTypes[2]= [];
        this.clientContactTypes[3]= [];
        this.clientContactTypes[4]= [];
        this.clientContactTypes[5]= [];

        /* Bring back for email autofill
        this.clientTypeForm.addControl("contact_type_email0-4", new FormControl(""));
        this.clientEmails.push({
          address: ''
        })
        */

        for(let i=0; i < data.length; i++) {
          if (data[i].client_contact_type_id != 4){
            this.clientTypeForm.addControl("contact_type_" + data[i].client_contact_type_id, new FormControl(""));
          }
        }
    });

    this.client.getClientListLanguages$(contactUUID)
      .subscribe((data: any) => {
        this.languageList = data;
    });

    this.client.getClientListReferrals$(contactUUID)
      .subscribe((data: any) => {
        this.referralList = data;
    });
  }

/*  Add an extra empty email field */
addEmailClient(): void  {
    this.clientEmails.push({
        address: ''
    })
    const email_i=this.clientEmails.length-1;
    const preappendtype = "contact_type_email"+email_i+"-4";
    this.clientTypeForm.addControl(preappendtype, new FormControl(""));
}

onChangeEmail( index:number, fieldValue: any):void {
  this.clientEmails[index].address = fieldValue.value;
  console.log(this.clientEmails[index].address);
  
}

/* autocomplete */
onChangeAutoEmail(fieldValue: any, fieldToQuery: string, index:number):void {

  const contactUUID = this.tokenStorage.getToken() || "";
  this.clientEmails[index].address = fieldValue.value;

  this.client.getAutoClientsName$(contactUUID, this.autoClientsName, fieldToQuery).subscribe({
    next: (data:any) => {
      this.update_message = "recherche effectuée";
      console.log("Success auto finding clients", data);
      this.clientAutoInfo = data.records;
      console.log("clients auto", this.clientAutoInfo);
      //this.router.navigate(['/clients']);
    },
    error: (err: any) => {
      console.log("Something went wrong getting the client: ", err)

    }
  })


}

/* autocomplete */
onChangeAutoName(fieldValue: any, fieldToQuery: string):void {
  const contactUUID = this.tokenStorage.getToken() || "";


  this.autoClientsName = fieldValue.value;
  console.log('searching for: ',this.autoClientsName);

  this.client.getAutoClientsName$(contactUUID, this.autoClientsName, fieldToQuery).subscribe({
    next: (data:any) => {
      this.update_message = "recherche effectuée";
      console.log("Success auto finding clients", data);
      this.clientAutoInfo = data.records;
      console.log("clients auto", this.clientAutoInfo);
      //this.router.navigate(['/clients']);
    },
    error: (err: any) => {
      console.log("Something went wrong getting the client: ", err)

    }
  })
}

/*redirect to client page */
goToAutoName($event: any, clientID: any):void {
  console.log("Go to client: ", $event);
  console.log("Client Id: ", clientID);
  console.log("Go to target: ", $event.target);
/*
  if ($event.value.indexOf(clientID) === 0) {
    console.log ('newa');
  }
*/

var str = clientID; 
var id_pre_str = str.substring(0,3);
var id_str = str.substring(3);

  if( Number.isInteger(Number(id_str)) && (id_str != '') && (id_pre_str == 'ID ') ){
    this.router.navigate(['/client/'+id_str+'/editer']);
  }else {
    console.log ('id not in the right format');

  }
}

removeEmailClient(uId: number): void  {
  let potato = this.clientEmails.splice(uId, 1);
  const preappendtype = "contact_type_email"+uId+"-4";
  this.clientTypeForm.controls[preappendtype].patchValue("");
  //console.log(uId);
  //call remove client info here
} 

goToTop() {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
}

onSubmit(values: any, contactValues: any ): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    console.log('values', values);
    console.log('contactValues', contactValues);

    let clientInfos: any = {
      first_name: this.addClientForm.get('first_name')!.value,
      last_name: this.addClientForm.get('last_name')!.value,
      gender: this.addClientForm.get('gender')!.value,
      address: this.addClientForm.get('address')!.value,
      address2: this.addClientForm.get('address2')!.value,
      province: this.addClientForm.get('province')!.value,
      postalcode: this.addClientForm.get('postalcode')!.value,
      city: this.addClientForm.get('city')!.value,
      country: this.addClientForm.get('country')!.value,
      client_language_id: this.addClientForm.get('language')!.value,
      client_referral_id: this.addClientForm.get('referral')!.value,
      client_referral_note: this.addClientForm.get('referral_note')!.value,
      contacts: [contactValues],
    };

    console.log('clientInfos', clientInfos);

    Object.keys(this.clientTypeForm.controls).forEach(key => {
      let typeId = [key].toString().replace("contact_type_", "");

      clientInfos.contacts.push({
        value: this.clientTypeForm.controls[key].value,
        client_contact_type_id: parseInt(typeId)
      })
    });

    this.client.addClient$(contactUUID, clientInfos).subscribe({
      next: (data: any) => {
        console.log("Data --> ", data);
        this.router.navigate(['/clients']);
      },
      error: (err: any) => {
        console.log("Something went wrong: ", err.statusText)
      }
    });

  }
}